import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Paragraph } from "components/core/Typography";

import "./Pill.scss";

function Pill(props) {
	const { label, onClick, labelProps, className } = props;

	return (
		<button type="button" className="button-pill" onClick={onClick}>
			<Paragraph
				className={classnames("pill", className)}
				{...labelProps}
			>
				{label}
			</Paragraph>
		</button>
	);
}

Pill.propTypes = {
	label: PropTypes.string,
	onClick: PropTypes.func,
	labelProps: PropTypes.object,
	className: PropTypes.string
};

Pill.defaultProps = {
	label: "",
	onClick: () => { },
	labelProps: {}
};

export default Pill;
